module.exports = __webpack_public_path__ + "static/media/play.00986653.svg";